export default __webpack_public_path__ + "static/media/userGroups.24f36398.svg";